import { useTranslation } from 'react-i18next';
import { PostModal, PostModalProps } from '../shared';
import { Template } from './template';

export type TiktokTagPostDetailsModalProps = Pick<PostModalProps, 'posts'>;

export const TiktokTagPostDetailsModal = ({ posts }: TiktokTagPostDetailsModalProps) => {
  const { t } = useTranslation();

  return (
    <PostModal posts={posts}>
      <PostModal.Title>{t('Post Detail')}</PostModal.Title>
      <Template />
    </PostModal>
  );
};
